module.exports = __webpack_public_path__ + "img/sound-volume.9ad6a3be.svg";